import { render, staticRenderFns } from "./ListTurno.vue?vue&type=template&id=0af22a89&"
import script from "./ListTurno.vue?vue&type=script&lang=js&"
export * from "./ListTurno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports